import { Textarea } from "@/components/ui/textarea";
import { BaseQuestionProps } from "../..";
import { cn } from "@/lib/utils";

interface TextAreaQuestionProps extends BaseQuestionProps {
  className?: string;
}

export const TextAreaQuestion: React.FC<TextAreaQuestionProps> = ({ field, placeholder, disabled, className }) => {
  return (
    <Textarea
      {...field}
      placeholder={placeholder}
      disabled={disabled}
      onChange={field.onChange}
      className={cn(
        `${disabled ? "border-gray-400 bg-gray-200" : "border-gray-200"} my-2 w-full font-light sm:max-w-[50%] md:my-3 md:max-w-[70%]`,
        className,
      )}
    />
  );
};
